import { getApiUrl } from './request';
import storage from 'local-storage-fallback';

export class TokenManager {
  private static token: string | null = null;
  private static refreshPromise: Promise<string> | null = null;

  // Function to set token (called after login or refresh)
  static setToken(newToken: string) {
    this.token = newToken;
    storage.setItem('token', newToken);
  }

  // Function to get the current token
  static async getToken(): Promise<string> {
    if (this.token) return this.token;

    const storedToken = storage.getItem('token');
    if (storedToken) {
      this.token = storedToken;
      return storedToken;
    }

    return this.refreshToken();
  }

  // Function to refresh token (calls the API)
  static async refreshToken(): Promise<string> {
    if (this.refreshPromise) {
      return this.refreshPromise; // Avoid duplicate requests
    }

    this.refreshPromise = fetch(getApiUrl('auth/refresh'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.token}`,
      },
    })
      .then(async res => {
        if (!res.ok) throw new Error('Failed to refresh token');
        const data = await res.json();
        this.setToken(data.token);
        return data.token;
      })
      .finally(() => {
        this.refreshPromise = null; // Clear refresh promise after completion
      });

    return this.refreshPromise;
  }
}
